import * as ApiManager from '../_manager';

export const adminCompany = {
  list: (payload) => {
    return ApiManager.callApi(`/admin/company/list`, payload);
  },
  get: (payload) => {
    return ApiManager.callApi(`/admin/company/get`, payload);
  },
  update: payload => {
    return ApiManager.callApi ('/admin/company/update', payload);
  },
  consumeAddOns: payload => {
    return ApiManager.callApi('/admin/company/consumeAddOns', payload);
  },
  logoutMembers: payload => {
    return ApiManager.callApi('/admin/company/logoutMembers', payload);
  },
};
